
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1159:576)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}}),_c('path',{attrs:{"d":"M25 13c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm4.596 5.404a.595.595 0 00-.763-.067c-2.89 2.028-4.52 3.23-4.894 3.602a1.502 1.502 0 000 2.122 1.502 1.502 0 002.122 0c.219-.22 1.418-1.851 3.598-4.897a.59.59 0 00-.063-.76zM30.5 22a1 1 0 100 2 1 1 0 000-2zm-11 0a1 1 0 100 2 1 1 0 000-2zm2.318-3.596a1 1 0 10-1.414 1.416 1 1 0 001.414-1.416zM25 16.5a1 1 0 100 2 1 1 0 000-2z","fill":"#0FB400"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1159:576","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1159:576"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1159:576","result":"shape"}})])])])
          )
        }
      }
    